import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "api/endpoint";
import { AssetValidationCategory } from "../../api/assetValidationCategory";
import { AssetState, AssetStatus } from "../components/assets-table";
import { FilterName, FilterTypePayments, PaymentsSortingBase, PaymentsTableColumns } from "./payment-table-columns";

export interface PaymentQuerry extends AttributesMixin<typeof PaymentQuerry> { }
@define
export class PaymentQuerry extends Model {
    static endpoint = restfulIO('api/v1/ingest/payments/assets');

    getSort = (params) => {
        const sortModel = params && params.request && params.request.sortModel && params.request.sortModel[0];
        if (sortModel) {
            if (Number(sortModel.colId) === PaymentsTableColumns.Status) {
                return {
                    sortBy: PaymentsSortingBase.AssetState.toString(),
                    asc: String(sortModel.sort === 'desc' ? false : true)
                }
            }
            else {
                return {
                    sortBy: PaymentsSortingBase[PaymentsTableColumns[Number(sortModel.colId)]].toString(),
                    asc: String(sortModel.sort === 'desc' ? false : true)
                }

            }
        }
        else {
            return {
                asc: true
            }
        }
    }

    filters = (params) => params && params.request && params.request.filterModel;


    getFilterForStatus = (status) => {
        switch (status) {
            case AssetStatus.PassValidationNewAsset:
                return {
                    validationCategories: AssetValidationCategory.passesValidationNewAsset,
                    assetStates: AssetState.Draft
                }
            case AssetStatus.PassValidationModifiedAsset:
                return {
                    validationCategories: AssetValidationCategory.passesValidationModifiedAsset,
                    assetStates: AssetState.Draft
                }

            case AssetStatus.RequireReview:
                return {
                    validationCategories: AssetValidationCategory.requiresReview,
                    assetStates: AssetState.Draft
                }

            case AssetStatus.Duplicated:
                return {
                    validationCategories: AssetValidationCategory.duplicateRecordsWithinExistingAssets,
                    assetStates: AssetState.Draft
                }

            case AssetStatus.ModifiesExistingAsset:
                return {
                    validationCategories: AssetValidationCategory.modifiesExistingAssets,
                    assetStates: AssetState.Draft
                }

            case AssetStatus.Conflict:
                return {
                    validationCategories: AssetValidationCategory.conflictsWithExistingFiles,
                    assetStates: AssetState.Draft
                }

            case AssetStatus.Digitized:
                return {
                    validationCategories: null,
                    assetStates: AssetState.Digitized
                }

            default:
                return {
                    validationCategories: null,
                    assetStates: null
                };
        }
    }

    parseFilter = (filter) => {
        if (filter) {
            return Object.keys(filter).reduce((acc, key) => {
                if (Number(key) === PaymentsTableColumns.Status) {
                    const statuses = filter[Number(key)].values.map((status) => this.getFilterForStatus(status)).reduce((acc, val) => {
                        if (val.validationCategories != null) {
                            acc.validationCategories = acc.validationCategories ? [...acc.validationCategories, val.validationCategories] : [val.validationCategories];
                        }
                        if (val.assetStates != null) {
                            acc.assetStates = acc.assetStates ? [...acc.assetStates, val.assetStates] : [val.assetStates]
                        }
                        return acc;
                    }, {})
                    return {
                        ...acc,
                        ...statuses
                    }
                }
                else {
                    const col = FilterTypePayments[PaymentsTableColumns[Number(key)]];
                    acc[FilterName[FilterTypePayments[col]]] = filter[Number(key)].filter;
                    acc['filterType'] = col;
                }
                return acc;
            }, {})
        }
    }

    getDataSource = (jobId, fetch) => ({
        getRows: (params) => {
            const payload = {
                jobId,
                skip: 0,
                take: 100000,
                ...this.getSort(params),
                ...this.parseFilter(this.filters(params))
            }
            fetch({ params: payload })
                .then((assets) => params.successCallback(assets.items.models, assets.count))
        }
    });
}
